export const STORAGE_KEYS = {
  authToken: "authToken",
  user: "user",
  selectedMenu: "selectedMenu",
  menuItemListState: "menuItemListState",
  reportTabValue: "reportTabValue",
  menuItemsPageState: "menuItemsPageState",
  weeklyGroceryOrdersState: "weeklyGroceryOrdersState",
};
